import { render, staticRenderFns } from "./BadgeUpload.vue?vue&type=template&id=2674bd93&scoped=true"
import script from "./BadgeUpload.vue?vue&type=script&lang=js"
export * from "./BadgeUpload.vue?vue&type=script&lang=js"
import style0 from "./BadgeUpload.vue?vue&type=style&index=0&id=2674bd93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2674bd93",
  null
  
)

export default component.exports